export default __webpack_public_path__ + "static/media/feed.c188587f.svg";